#import "./SentenceDetails.graphql"
fragment sentenceGroupDetails on SentenceGroupType {
  reading {
    id
    description
    user {
      username
    }
  }
  category {
    id
    description
    order
  }
  sentences {
    ...sentenceDetails
  }
  recordings {
    id
  }
}
